import {
  BufferSizeType,
  PDFSettings,
  RenderingEngine,
  RenderQuality,
} from '@readcloud/data';

export const renderQualityOptions: RenderQuality[] = ['High', 'Medium'];

export const prerenderAmountLabels: {
  [k in BufferSizeType]: RenderQuality | 'Minimum';
} = {
  1: 'Minimum',
  3: 'Medium',
  5: 'High',
};
export const bufferSizes: { [k in BufferSizeType]: k } = {
  1: 1,
  3: 3,
  5: 5,
};
export const prerenderAmountOptions = Object.values(bufferSizes);
export const prerenderAmountOptionsLabels = prerenderAmountOptions.map(
  (amount) => `${prerenderAmountLabels[amount]} (${amount})`
);

export const renderQualityOptionToEngine: {
  [k in RenderQuality]: RenderingEngine;
} = {
  High: 'Web',
  Medium: 'Native',
};

export const renderModeOptions: Array<PDFSettings['renderMode']> = [
  'canvas',
  'svg',
];

export type EpubTheme = 'day' | 'night' | 'sepia';
